export const ACKNOWLEDGEMENT_CHECKED_KEY= "acknowledgement_checked"

export function getDaysAgoAtMidnight(numDays) {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const result = new Date(startOfToday)
  result.setDate(result.getDate() - numDays)
  return result
}

const DEFAULT_LOGIN_FRAUD_ACKNOWLEDGMENT_TIME = 0
export async function getFraudAcknowledgementThreshold() {
  try {
    const res = await fetch('/eci/login/fraud-acknowledgement-time')
    if (!res.ok) {
      console.warn(`HTTP ${res.status} returned for fraud acknowledgement time fetch`)
      return DEFAULT_LOGIN_FRAUD_ACKNOWLEDGMENT_TIME
    }

    return await res.json()
  } catch (err) {
    console.warn("Error fetching acknowledgement threshold", err)
    return DEFAULT_LOGIN_FRAUD_ACKNOWLEDGMENT_TIME
  }
}